NtechApp.HotelCollection = function($view) {
    var me = this;

    this._$view = null;

    this._touchClickEvent = null;
    this._lightBoxInstances = [];

    this._css = {
        ids: {
        },

        classes: {
        },

        data: {
        }
    }

    this._construct = function () {
        me._$view = $view;

        me._touchClickEvent = new NtechApp.TouchClickEvent();

       // me._createFlickableSlider();
        me._createProductsGrid();

        me._bindEvents();

        $("#pageMainHeading > .desktopHeading").imageScroll({
            holderMaxHeight: 220,
            container: $("#pageMainHeading")
        });
    }

    this._bindEvents = function () {
        me._$view.find(".productsGrid").on("mouseenter.NtechApp.HotelCollection", ".gridItem", function() {
            $(this).find("img").addClass("selected");
            $(this).find(".name").addClass("selected");
        });

        me._$view.find(".productsGrid").on("mouseleave.NtechApp.HotelCollection", ".gridItem", function() {
            $(this).find("img").removeClass("selected");
            $(this).find(".name").removeClass("selected");
        });
    }

    this._unbindEvents = function () {
        me._productsGrid.destruct();
        for(var i = 0; i < me._lightBoxInstances.length; i++)
            me._lightBoxInstances[i].destroy();

        me._$view.find(".productsGrid").off("mouseenter.NtechApp.HotelCollection");
        me._$view.find(".productsGrid").off("mouseleave.NtechApp.HotelCollection");

        $("window").off("resize.NtechApp.HotelCollection");

        $("#pageMainHeading > .desktopHeading").imageScroll("destruct");
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

//NtechApp.HotelCollection.prototype._createFlickableSlider = function() {
//    var me = this;
//
//    this._touchClickEvent.listen($(".firstSliderControls"), ".towelsControl", function(event) {
//        me._selectControlItem($(event.target));
//        sliderGrid.setFilter("towels");
//    });
//
//    this._touchClickEvent.listen($(".firstSliderControls"), ".beddingsControl", function(event) {
//        me._selectControlItem($(event.target));
//        sliderGrid.setFilter("beddings");
//    });
//
//    this._touchClickEvent.listen($(".firstSliderControls"), ".robesControl", function(event) {
//        me._selectControlItem($(event.target));
//        sliderGrid.setFilter("robes");
//    });
//
//    this._touchClickEvent.listen($(".firstSliderControls"), ".hotelAmenitiesControl", function(event) {
//        me._selectControlItem($(event.target));
//        sliderGrid.setFilter("hotelAmenities");
//    });
//
//    var sliderGrid = new Gridifier($(".sliderGrid"), {
//        class: "gridItem",
//        gridTransformType: "disabled",
//        filter: {
//            initial: "towels",
//
//            towels: function(item) {
//                return $(item).hasClass("towels");
//            },
//
//            beddings: function(item) {
//                return $(item).hasClass("beddings");
//            },
//
//            robes: function(item) {
//                return $(item).hasClass("robes");
//            },
//
//            hotelAmenities: function(item) {
//                return $(item).hasClass("hotel-amenities");
//            }
//        }
//    });
//
//    sliderGrid.onConnectionCreate(function() {
//        sliderGrid.silentRender(sliderGrid.getForSilentRender(true));
//    });
//
//    $(document).on("scroll.sliderGrid", function() {
//        sliderGrid.silentRender(sliderGrid.getForSilentRender(true));
//    });
//
//    sliderGrid.silentAppend(sliderGrid.collectNew());
//};

NtechApp.HotelCollection.prototype._itemsToBatches = function(items, batchSize) {
    var itemBatches = [];
    var itemsCountInCurrentBatch = 0;
    var itemsBatch = [];
    var wasLastBatchPushed = false;

    for(var i = 0; i < items.length; i++) {
        itemsBatch.push(items[i]);
        wasLastBatchPushed = false;

        itemsCountInCurrentBatch++;
        if(itemsCountInCurrentBatch == batchSize) {
            itemBatches.push(itemsBatch);
            itemsBatch = [];
            wasLastBatchPushed = true;
            itemsCountInCurrentBatch = 0;
        }
    }

    if(!wasLastBatchPushed)
        itemBatches.push(itemsBatch);

    return itemBatches;
};

NtechApp.HotelCollection.prototype._getSubfilterItemsCount = function() {
    return this._subfilterItemsCount;
};

NtechApp.HotelCollection.prototype._buildSubfilterFunctions = function(subfilterNumber, items, filters) {
    var buildSubfilterFunc = function(i) {
        return function(item) {
            return $(item).attr("data-subfilter-category") == i;
        }
    }
    filters["subfilter" + subfilterNumber] = buildSubfilterFunc(subfilterNumber);

    for(var i = 0; i < items.length; i++) {
        items[i].setAttribute("data-subfilter-category", subfilterNumber);
    }

    return "subfilter" + subfilterNumber;
};

NtechApp.HotelCollection.prototype._getFilters = function() {
    var filterCats = this._$view.find(".productsGrid").attr("data-filter-categories").split(";");
    var filters = {};
    this._filterNames = [];

    for(var i = 0; i < filterCats.length; i++) {
        var buildFilterFunc = function(i, filterCategory) {
            return function(item) {
                return $(item).attr("data-filter-category") == filterCategory;
            }
        }

        filters["filter" + filterCats[i]] = buildFilterFunc(i, filterCats[i]);
        var filterName = {name: "filter" + filterCats[i], subfilterNames: []};

        //var $filterItems = this._$view.find(".productsGrid").find("[data-filter-category=" + filterCats[i] + "]");
        var filterItems = this._$view.find(".productsGrid").get(0).querySelectorAll("[data-filter-category='" + filterCats[i] + "']");
        var filterItemBatches = this._itemsToBatches(filterItems, this._getSubfilterItemsCount());

        for(var j = 0; j < filterItemBatches.length; j++) {
            filterName.subfilterNames.push(this._buildSubfilterFunctions(j, filterItemBatches[j], filters));
        }
        this._filterNames.push(filterName);
    }

    return filters;
};

NtechApp.HotelCollection.prototype._selectFilter = function(filterName) {
    for(var i = 0; i < this._filterNames.length; i++) {
        if(this._filterNames[i].name == filterName) {
            this._selectedFilterIndex = i;
            this._selectedSubfilterIndex = 0;
            break;
        }
    }

    this._productsGrid.setFilter([
        this._filterNames[this._selectedFilterIndex].name,
        this._filterNames[this._selectedFilterIndex].subfilterNames[0]
    ]);
};

NtechApp.HotelCollection.prototype._hasPrevSubfilter = function() {
    return (this._selectedSubfilterIndex == 0) ? false : true;
};

NtechApp.HotelCollection.prototype._hasNextSubfilter = function() {
    var subfiltersCount = this._filterNames[this._selectedFilterIndex].subfilterNames.length;
    return (this._selectedSubfilterIndex == subfiltersCount - 1) ? false : true;
};

NtechApp.HotelCollection.prototype._selectPrevSubfilter = function() {
    if(this._currentProductsGridBp != "-=979")
        this._productsGrid.setToggle("slideLeftInRightOut");
    else
        this._productsGrid.setToggle("fade");

    this._selectedSubfilterIndex--;
    this._productsGrid.setFilter([
        this._filterNames[this._selectedFilterIndex].name,
        this._filterNames[this._selectedFilterIndex].subfilterNames[this._selectedSubfilterIndex]
    ]);
};

NtechApp.HotelCollection.prototype._selectNextSubfilter = function() {
    if(this._currentProductsGridBp != "-=979")
        this._productsGrid.setToggle("slideLeftOutRightIn");
    else
        this._productsGrid.setToggle("fade");

    this._selectedSubfilterIndex++;
    this._productsGrid.setFilter([
        this._filterNames[this._selectedFilterIndex].name,
        this._filterNames[this._selectedFilterIndex].subfilterNames[this._selectedSubfilterIndex]
    ]);
};

NtechApp.HotelCollection.prototype._createProductsGrid = function() {
    var me = this;

    var items = this._$view.find(".productsSliderControls").get(0).querySelectorAll(".item");
    for(var i = 0; i < items.length; i++) {
        this._touchClickEvent.listen($(items[i]), function(event) {
            me._productsGrid.setToggle("fade");
            me._selectControlItem($(event.target));
            me._selectFilter("filter" + event.target.getAttribute("data-filter-category"));
            updateButtonsDisplay();

            var filterCategory = event.target.getAttribute("data-filter-category");
            var $filtersText = me._$view.find(".filtersText");
            $filtersText.find(".text").css("display", "none");
            $filtersText.find("[data-filter-category-text=" + filterCategory + "]").css("display", "block");
        });
    }

    var updateButtonsDisplay = function() {
        if(me._hasPrevSubfilter())
            $prevButton.css("visibility", "visible");
        else
            $prevButton.css("visibility", "hidden");

        if(me._hasNextSubfilter())
            $nextButton.css("visibility", "visible");
        else
            $nextButton.css("visibility", "hidden");
    }

    var $productsGridWrapper = this._$view.find(".productsGridWrapper");
    var $nextButton = $productsGridWrapper.find(".nextButton");
    var $prevButton = $productsGridWrapper.find(".prevButton");
    this._touchClickEvent.listen($prevButton, function(event) {
        if(!me._hasPrevSubfilter())
            return;
        me._selectPrevSubfilter();
        updateButtonsDisplay();
    });

    this._touchClickEvent.listen($nextButton, function(event) {
        if(!me._hasNextSubfilter())
            return;
        me._selectNextSubfilter();
        updateButtonsDisplay();
    });

    this._touchClickEvent.listen($productsGridWrapper, ".gridItem .name", function(event) {
        var $name = $(event.target);
        $name.siblings("a").trigger("click");
    });

    var updateSubfilterItemsCount = function() {
        if(me._currentProductsGridBp == "default")
            me._subfilterItemsCount = 8;
        else if(me._currentProductsGridBp == "1600+")
            me._subfilterItemsCount = 12;
        else if(me._currentProductsGridBp == "-=979")
            me._subfilterItemsCount = 4;
    }

    $(window).on("resize.NtechApp.HotelCollection", function() {
        me._currentProductsGridBp = window.getComputedStyle($productsGridWrapper.get(0), ':after').getPropertyValue("content").replace(/"/g, "");
        me._currentProductsGridBp = me._currentProductsGridBp.replace(/'/g, ""); // Android fix

        if(me._currentProductsGridBp != me._lastProductsGridBp) {
            updateSubfilterItemsCount();
            me._selectedSubfilterIndex = 0;

            me._productsGrid._settings._filterApi._filterFunctions = me._getFilters();
            me._productsGrid.setToggle("fade");
            me._productsGrid.setFilter([
                me._filterNames[me._selectedFilterIndex].name,
                me._filterNames[me._selectedFilterIndex].subfilterNames[me._selectedSubfilterIndex]
            ]);
            updateButtonsDisplay();

            me._lastProductsGridBp = me._currentProductsGridBp;
        }
    });

    var initProductsGridBp = function() {
        me._currentProductsGridBp = window.getComputedStyle($productsGridWrapper.get(0), ':after').getPropertyValue("content").replace(/"/g, "");
        me._currentProductsGridBp = me._currentProductsGridBp.replace(/'/g, ""); // Android fix
        me._lastProductsGridBp = me._currentProductsGridBp;
        updateSubfilterItemsCount();
    }

    //$(window).on("load.NtechApp.HotelCollection", function() {
    //    initProductsGridBp();
    //});

    initProductsGridBp();
    var filters = this._getFilters();

    this._selectedFilterIndex = 0;
    this._selectedSubfilterIndex = 0;

    if(window.NtechApp.loadShopFilter) {
        window.NtechApp.loadShopFilter = false;
        var filterNum = window.NtechApp.loadShopFilterName.match(/\d+/)[0];
        filters.initial = [this._filterNames[filterNum - 1].name, this._filterNames[0].subfilterNames[0]];
        this._selectedFilterIndex = filterNum - 1;
        this._selectControlItem(me._$view.find(".controls [data-filter-category=" + filterNum + "]"));
    }
    else
        filters.initial = [this._filterNames[0].name, this._filterNames[0].subfilterNames[0]];

    this._productsGrid = new Gridifier(this._$view.find(".productsGrid"), {
        //query: "img",
        class: "gridItem",
        resolveImages: true,
        filter: filters,
        align: "top",
        toggle: "fade"
    });
    this._productsGrid.onConnectionCreate(function() {
        $(".collectionsLoader").addClass("hide");
    });

    var toggleFunctions = this._productsGrid._settings._toggleApi._toggleFunctions;
    toggleFunctions["slideLeftInRightOut"] = {
        show: function(item, g, h, j, k, l, m, n, o, p, q, r, s) {
            toggleFunctions["slideLeftWithFade"].show(item, g, h, j, k, l, m, n, o, p, q, r, s);
        },

        hide: function(item, g, h, j, k, l, m, n, o, p, q, r, s) {
            toggleFunctions["slideRightWithFade"].hide(item, g, h, j, k, l, m, n, o, p, q, r, s);
        }
    }

    toggleFunctions["slideLeftOutRightIn"] = {
        show: function(item, g, h, j, k, l, m, n, o, p, q, r, s) {
            toggleFunctions["slideRightWithFade"].show(item, g, h, j, k, l, m, n, o, p, q, r, s);
        },

        hide: function(item, g, h, j, k, l, m, n, o, p, q, r, s) {
            toggleFunctions["slideLeftWithFade"].hide(item, g, h, j, k, l, m, n, o, p, q, r, s);
        }
    }

    //this._productsGrid.setFilter(this._filterNames[0].name);
    this._productsGrid.append(this._productsGrid.collectNew());
    updateButtonsDisplay();

    var enableLoader = function() { $("<div id='loader'><div class='cssload-loader'></div></div>").appendTo("body"); };
    var disableLoader = function() { $("#loader").remove(); };
    var enableOverlay = function() { $("<div id='imagelightboxOverlay'></div>").appendTo("body"); };
    var disableOverlay = function() { $("#imagelightboxOverlay").remove(); };
    var createCaption = function() {
        $("<div id='imagelightboxCaption'></div>'").appendTo("body");
        $("<div class='content'></div>").appendTo("#imagelightboxCaption");
        $("<div class='headingIcon'></div>").appendTo("#imagelightboxCaption .content");
        $("<img/>").attr("src", "/bundles/ntechclient/img/icons/products.png").appendTo("#imagelightboxCaption .headingIcon");
        $("<div class='heading headingFont'></div>").appendTo("#imagelightboxCaption .content");
        $("<div class='description'></div>").appendTo("#imagelightboxCaption .content");
        $("<div class='price headingFont'></div>").appendTo("#imagelightboxCaption .content");
    };
    var deleteCaption = function() {
        $("#imagelightboxCaption").removeClass("visible");
        var oldCaption = document.getElementById("imagelightboxCaption");
        if(oldCaption == null)
            return;
        oldCaption.removeAttribute("id");

        setTimeout(function() {
            $(oldCaption).remove();
            //if(oldCaption.length > 0)
            //    $("#imagelightboxCaption").remove();
        }, 500);
        //$("#imagelightboxCaption").animate({opacity: 0}, 250, function() { $("#imagelightboxCaption").remove(); });
    };
    var updateCaption = function() {
        var $currentItem = $productsGridWrapper.find("a[href='" + $("#imagelightbox").attr('src') + "'] img");
        $("#imagelightboxCaption .heading").text($currentItem.attr("data-image-heading"));
        $("#imagelightboxCaption .description").text($currentItem.attr("data-image-description"));
        $("#imagelightboxCaption .price").text("$" + $currentItem.attr("data-image-price"));
        $("#imagelightboxCaption").css("display", "block");

        if($currentItem.attr("data-image-price").length > 1)
            $("#imagelightboxCaption .price").css("display", "block");
        else
            $("#imagelightboxCaption .price").css("display", "none");

        setTimeout(function() {
            if($("#imagelightboxCaption").length > 0)
                $("#imagelightboxCaption").addClass("visible");
        }, 100);
        //$("#imagelightboxCaption").addClass("visible");
    }
    var createCloseButton = function(instance) {
        $("<div id='imagelightboxCloseButton' class='headingFont'>CLOSE</div>").appendTo("body");
        me._touchClickEvent.listen($("#imagelightboxCloseButton"), function(event) {
            disableOverlay();
            deleteCaption();
            deleteCloseButton();
            deleteArrows();
            instance.quitImageLightbox();
            return false;
        });
    }
    var deleteCloseButton = function() {
        $("#imagelightboxCloseButton").remove();
    }
    var createArrows = function(instance) {
        $("<div id='imagelightboxLeftArrowButton'><div class='arrowWrapper'><div class='arrow'></div></div></div>").appendTo("body");
        $("<div id='imagelightboxRightArrowButton'><div class='arrowWrapper'><div class='arrow'></div></div></div>").appendTo("body");

        me._touchClickEvent.listen($("#imagelightboxLeftArrowButton"), function() {
            instance.loadImage("left");
        });
        me._touchClickEvent.listen($("#imagelightboxRightArrowButton"), function() {
            instance.loadImage("right");
        });
    }
    var deleteArrows = function() {
        $("#imagelightboxLeftArrowButton").remove();
        $("#imagelightboxRightArrowButton").remove();
    }

    var filterCats = this._$view.find(".productsGrid").attr("data-filter-categories").split(";");
    for(var i = 0; i < filterCats.length; i++) {
        var buildCategoryGallery = function(category) {
            var instance = $productsGridWrapper.find("[" + category + "] a").imageLightbox({
                quitOnDocClick: false,
                onLoadStart: function() { enableLoader(); },
                onLoadEnd: function() { disableLoader(); updateCaption(); },
                onStart: function() {  enableOverlay(); createCaption(); createCloseButton(instance); createArrows(instance); },
                onEnd: function() { disableOverlay(); deleteCaption(); deleteCloseButton(); deleteArrows(); }
            });
            me._lightBoxInstances.push(instance);
        }

        buildCategoryGallery("data-filter-category=" + (i + 1));
    }

    //sliderGrid.onConnectionCreate(function() {
    //    sliderGrid.silentRender(sliderGrid.getForSilentRender(true));
    //});
    //
    //$(document).on("scroll.sliderGrid", function() {
    //    sliderGrid.silentRender(sliderGrid.getForSilentRender(true));
    //});
    //
    //sliderGrid.silentAppend(sliderGrid.collectNew());
};

NtechApp.HotelCollection.prototype._selectControlItem = function($control) {
    $.each($control.parent().find(".item"), function() {
        $(this).removeClass("active");
    });

    $control.addClass("active");
};